<template>
	<g id="icon--money">
        <path id="XMLID_2545_" class="st0" d="M316.8,576.1l-60.3-34.6c-5.3-3.1-12-1.2-15.1,4.1l-3.1,5.3c-3.1,5.3-1.2,12,4.1,15.1
    l60.3,34.6c5.3,3.1,12,1.2,15.1-4.1l3.1-5.3C324,585.9,322.1,579.2,316.8,576.1z" />
			<path id="XMLID_2544_" class="st0" d="M250.4,615.2l1.1,0l0.4-37.1l0.1-13.3l0.2-10.8c0-0.6,0-1.2-0.1-1.7l-15.9-30.7l1-92.7
    l-54.7-0.6l-0.9,94.7c-12.6,4.2-21.7,16.1-21.9,30.2l-0.2,10.8l-0.1,13.3l-0.2,20.3c2.6-3.7,6.9-6,11.8-5.9
    c6.6,0.1,12,4.6,13.6,10.7c2.5-2,5.7-3.3,9.3-3.3c7.2,0.1,13.1,5.6,14.1,12.5c2.5-2,5.7-3.3,9.2-3.2c5.1,0.1,9.5,2.8,12.1,6.9l0.4,0
    c2.6-2.9,6.5-4.6,10.6-4.6C244.1,610.5,247.8,612.3,250.4,615.2z" />
			<rect id="XMLID_2543_" x="167.2" y="478.8" transform="matrix(7.004525e-03 1 -1 7.004525e-03 779.2166 351.8311)" class="st1" width="90.6" height="178.9" />
			<rect id="XMLID_2542_" x="163.6" y="489.2" transform="matrix(7.004525e-03 1 -1 7.004525e-03 783.7117 363.4281)" class="st2" width="90.6" height="174.3" />
			<g id="money-front-left">
            <rect id="XMLID_2541_" x="157.4" y="499.2" transform="matrix(7.004525e-03 1 -1 7.004525e-03 785.2476 378.8207)" class="st3" width="89" height="171.1" />
				<circle id="XMLID_1988_" class="st4" cx="201.9" cy="584.9" r="31.1" />
				<g id="XMLID_161_" class="st5">
                <path id="XMLID_162_" class="st6" d="M198.3,615.8l-0.1-7.2c-2.1-0.1-6.4-0.8-10.8-4.5l4.7-7.6c2.1,1.9,4.8,3.3,7.8,3.3
            c2,0,3.6-0.5,4.5-1.4c0.8-0.7,1.4-1.8,1.4-3c0-1.2-0.5-2.1-1.4-2.8c-1.1-1-2.9-1.5-4.8-2.3l-4-1.7c-2.4-1.1-4.9-2.2-6.7-4
            c-2.4-2.4-3.4-5.3-3.4-8.7c0-4.5,1.6-8.2,3.8-10.6c2-2.2,5-3.9,8.6-4.5l-0.1-8.1l6.4,0l0.1,7.8c2.8,0.1,5.6,0.7,8.6,2.3
            c2.4,1.3,4.6,2.8,6.4,4.8l-5.2,7.9c-0.6-0.6-2.3-2.3-4.7-3.7c-1.9-1.1-3.9-1.9-6.6-1.9c-1.6,0-3.3,0.3-4.8,1.5
            c-0.9,0.8-1.7,1.9-1.7,3.6c0,1.7,0.8,2.9,2.2,3.8c1.1,0.8,2.4,1.1,4.9,2.1l2.5,1c2.5,1,5.1,2.2,7.2,4.3c2.2,2.3,3.2,4.6,3.3,7.8
            c0,4.2-1.5,8-4,10.6c-1.9,1.9-4.7,3.4-7.8,4l0,7.2L198.3,615.8z" />
            </g>
				<polyline id="XMLID_1990_" class="st4" points="282.2,598.2 282.4,623.3 256.7,623.6  " />
				<polyline id="XMLID_2537_" class="st4" points="120.7,570.5 120.6,545.4 146.2,545.2  " />
        </g>
			<g id="XMLID_1991_">
            <path id="XMLID_2535_" class="st0" d="M184.7,640.1l-0.9-39.3c-0.1-5.2-4.5-9.4-9.6-9.2l-4.5,0.1c-5.2,0.1-9.4,4.5-9.2,9.6
        l0.9,39.3c0.1,5.2,4.5,9.4,9.6,9.2l4.5-0.1C180.7,649.6,184.8,645.3,184.7,640.1z" />
				<path id="XMLID_2532_" class="st7" d="M158.6,638.5l-0.9-34.8c-0.2-7.9,6.1-14.5,14-14.7c7.9-0.2,14.5,6.1,14.7,14l0.9,34.8
        c0.2,7.9-6.1,14.5-14,14.7C165.4,652.6,158.8,646.4,158.6,638.5z M163.1,603.5l0.9,34.8c0.1,5,4.3,8.9,9.3,8.8
        c5-0.1,8.9-4.3,8.8-9.3l-0.9-34.8c-0.1-5-4.3-8.9-9.3-8.8C167,594.4,163,598.5,163.1,603.5z" />
        </g>
			<g id="XMLID_1992_">
            <path id="XMLID_2530_" class="st0" d="M209.6,645.2l-0.9-39.3c-0.1-5.2-4.5-9.4-9.6-9.2l-4.5,0.1c-5.2,0.1-9.4,4.5-9.2,9.6
        l0.9,39.3c0.1,5.2,4.5,9.4,9.6,9.2l4.5-0.1C205.5,654.8,209.7,650.4,209.6,645.2z" />
				<path id="XMLID_2527_" class="st7" d="M183.4,643.6l-0.9-34.8c-0.2-7.9,6.1-14.5,14-14.7c7.9-0.2,14.5,6.1,14.7,14l0.9,34.8
        c0.2,7.9-6.1,14.5-14,14.7C190.2,657.8,183.6,651.5,183.4,643.6z M187.9,608.7l0.9,34.8c0.1,5,4.3,8.9,9.3,8.8
        c5-0.1,8.9-4.3,8.8-9.3l-0.9-34.8c-0.1-5-4.3-8.9-9.3-8.8C191.7,599.5,187.8,603.7,187.9,608.7z" />
        </g>
			<g id="XMLID_1993_">
            <path id="XMLID_2525_" class="st0" d="M232.8,645.1l-1-39.3c-0.1-5.2-4.5-9.4-9.6-9.2l-4.5,0.1c-5.2,0.1-9.4,4.5-9.2,9.6l0.9,39.3
        c0.1,5.2,4.5,9.4,9.6,9.2l4.5-0.1C228.7,654.6,232.8,650.3,232.8,645.1z" />
				<path id="XMLID_2522_" class="st7" d="M206.6,643.5l-0.9-34.8c-0.2-7.9,6.1-14.5,14-14.7c7.9-0.2,14.5,6.1,14.7,14l0.9,34.8
        c0.2,7.9-6.1,14.5-14,14.7C213.4,657.6,206.8,651.4,206.6,643.5z M211.1,608.4l0.9,34.8c0.1,5,4.3,8.9,9.3,8.8
        c5-0.1,8.9-4.3,8.8-9.3l-0.9-34.8c-0.1-5-4.3-8.9-9.3-8.8C214.9,599.3,211,603.5,211.1,608.4z" />
        </g>
			<g id="XMLID_1994_">
            <path id="XMLID_2520_" class="st0" d="M256,644.9l-0.9-39.3c-0.1-5.2-4.5-9.4-9.6-9.2l-4.5,0.1c-5.2,0.1-9.4,4.5-9.2,9.6l0.9,39.3
        c0.1,5.2,4.5,9.4,9.6,9.2l4.5-0.1C251.9,654.5,256,650.1,256,644.9z" />
				<path id="XMLID_2517_" class="st7" d="M229.9,643.2l-0.9-34.8c-0.2-7.9,6.1-14.5,14-14.7c7.9-0.2,14.5,6.1,14.7,14l0.9,34.8
        c0.2,7.9-6.1,14.5-14,14.7C236.7,657.4,230.1,651.1,229.9,643.2z M234.3,608.3l0.9,34.8c0.1,5,4.3,8.9,9.3,8.8
        c5-0.1,8.9-4.3,8.8-9.3l-0.9-34.8c-0.1-5-4.3-8.9-9.3-8.8C238.2,599.2,234.2,603.3,234.3,608.3z" />
        </g>
			<path id="XMLID_2515_" class="st8" d="M206.8,0c0,1,0,2.1,0,3.2l3.2,453.8" />
			<path id="XMLID_2514_" class="st9" d="M153.1,463.2l0-7.1c0-8.2,6.8-14.9,15-14.9l79.4,0.4c8.2,0,14.9,6.8,14.9,15l0,7.1
    c0,8.2-6.8,14.9-15,14.9l-79.4-0.4C159.8,478.2,153.1,471.4,153.1,463.2z" />
			<path id="XMLID_51_" class="st0" d="M345.9,591.2l3.1,5.3c3.1,5.3,9.8,7.1,15.1,4.1l60.3-34.6c5.3-3.1,7.1-9.8,4.1-15.1l-3.1-5.3
    c-3.1-5.3-9.8-7.1-15.1-4.1L350,576.1C344.7,579.2,342.8,586,345.9,591.2z" />
			<path id="XMLID_50_" class="st0" d="M426.6,610.5c4.1,0,8,1.8,10.6,4.6l0.4,0c2.5-4.1,7-6.8,12.1-6.9c3.5-0.1,6.7,1.2,9.2,3.2
    c0.9-6.9,6.9-12.4,14.1-12.5c3.5,0,6.8,1.3,9.3,3.3c1.7-6.1,7.1-10.6,13.6-10.7c4.9-0.1,9.1,2.2,11.8,5.9l-0.2-20.3l-0.1-13.3
    l-0.2-10.8c-0.2-14.1-9.3-26-21.9-30.2l-0.9-94.7l-54.7,0.6l1,92.7l-15.9,30.7c0,0.6,0,1.2-0.1,1.7l0.2,10.8l0.1,13.3l0.4,37.1
    l1.1,0C419.1,612.3,422.7,610.5,426.6,610.5z" />
			<path id="XMLID_28_" class="st8" d="M456.8,457.1l3.2-453.8c0.1-1.1,0-2.2,0-3.2" />
			<path id="XMLID_27_" class="st9" d="M498.8,494.3l-79.4,0.4c-8.2,0-15-6.6-15-14.9l0-7.1c0-8.2,6.6-15,14.9-15l79.4-0.4
    c8.2,0,15,6.6,15,14.9l0,7.1C513.7,487.5,507.1,494.3,498.8,494.3z" />
			<g id="XMLID_19_">
            <rect id="XMLID_26_" x="450.7" y="385.4" transform="matrix(0.1865 -0.9825 0.9825 0.1865 -59.838 869.6147)" class="st3" width="89" height="171.1" />
				<circle id="XMLID_25_" class="st4" cx="495.2" cy="470.8" r="31.1" />
				<g id="XMLID_22_" class="st5">
                <path id="XMLID_23_" class="st6" d="M504.7,441.3l-1.3,7.1c2,0.5,6.1,2,9.8,6.5l-6.1,6.6c-1.7-2.3-4.1-4.2-7-4.7
            c-2-0.4-3.6-0.2-4.7,0.5c-0.9,0.6-1.7,1.5-2,2.7c-0.2,1.2,0.1,2.1,0.8,3c0.9,1.2,2.5,2,4.2,3.2l3.6,2.4c2.2,1.5,4.3,3.1,5.8,5.2
            c1.9,2.8,2.3,5.9,1.7,9.2c-0.8,4.4-3.1,7.7-5.8,9.7c-2.4,1.8-5.7,2.8-9.3,2.7l-1.5,8l-6.3-1.2l1.5-7.7c-2.8-0.7-5.3-1.8-7.9-3.9
            c-2.1-1.7-3.9-3.6-5.4-5.9l6.6-6.7c0.5,0.7,1.8,2.7,3.9,4.5c1.6,1.5,3.5,2.6,6.1,3.1c1.5,0.3,3.3,0.3,5-0.6c1.1-0.6,2-1.6,2.4-3.2
            c0.3-1.7-0.2-3-1.4-4.2c-1-1-2.1-1.6-4.4-3l-2.3-1.4c-2.3-1.4-4.6-3.1-6.2-5.6c-1.7-2.6-2.3-5.1-1.7-8.3c0.8-4.1,3-7.6,5.9-9.6
            c2.2-1.5,5.3-2.5,8.4-2.4l1.3-7.1L504.7,441.3z" />
            </g>
				<polyline id="XMLID_21_" class="st4" points="419,442.3 423.7,417.6 448.9,422.3  " />
				<polyline id="XMLID_20_" class="st4" points="572.1,500.7 567.4,525.3 542.2,520.5    " />
        </g>
			<g id="XMLID_81_">
            <g id="XMLID_2_">
                <path id="XMLID_89_" class="st10" d="M570.8,626.9c-2.7,10.7-13.7,17.1-24.4,14.4L368,595.3c-10.7-2.7-17.1-13.7-14.4-24.4
            l23.3-90.5c2.7-10.7,13.7-17.1,24.4-14.4L579.7,512c10.7,2.7,17.1,13.7,14.4,24.4L570.8,626.9z" />
            </g>
				<rect id="XMLID_18_" x="449.3" y="417.3" transform="matrix(-0.2425 0.9702 -0.9702 -0.2425 1106.1317 149.7576)" class="st1" width="90.6" height="178.9" />
				<rect id="XMLID_17_" x="437.2" y="432.8" transform="matrix(-0.2425 0.9702 -0.9702 -0.2425 1103.9742 177.9418)" class="st2" width="90.6" height="174.3" />
				<g id="money-front-right">
                <rect id="XMLID_16_" x="457.7" y="417.7" transform="matrix(0.2149 -0.9766 0.9766 0.2149 -97.1981 885.5055)" class="st3" width="89" height="171.1" />
					<circle id="XMLID_8_" class="st4" cx="502.2" cy="503.1" r="31.1" />
					<g id="XMLID_9_" class="st5">
                    <path id="XMLID_11_" class="st6" d="M512.5,473.8l-1.5,7c2,0.6,6.1,2.2,9.6,6.8l-6.3,6.4c-1.7-2.3-3.9-4.3-6.9-4.9
                c-1.9-0.4-3.6-0.3-4.7,0.4c-0.9,0.5-1.8,1.4-2,2.6c-0.3,1.2,0,2.1,0.7,3c0.9,1.2,2.5,2.1,4.1,3.3l3.5,2.5
                c2.1,1.6,4.3,3.2,5.7,5.4c1.8,2.9,2.1,5.9,1.4,9.3c-1,4.4-3.4,7.6-6.1,9.5c-2.5,1.7-5.8,2.7-9.4,2.5l-1.7,7.9l-6.3-1.4l1.7-7.6
                c-2.7-0.8-5.3-2-7.8-4.1c-2.1-1.8-3.8-3.8-5.2-6.1l6.8-6.5c0.4,0.7,1.7,2.7,3.7,4.6c1.6,1.5,3.4,2.7,6,3.3c1.5,0.3,3.3,0.4,5-0.4
                c1.1-0.6,2.1-1.5,2.4-3.2c0.4-1.7-0.1-3-1.3-4.2c-0.9-1-2-1.6-4.3-3.1l-2.2-1.5c-2.2-1.5-4.5-3.2-6.1-5.8
                c-1.7-2.7-2.1-5.2-1.4-8.3c0.9-4.1,3.3-7.5,6.2-9.4c2.3-1.5,5.4-2.3,8.5-2.1l1.5-7L512.5,473.8z" />
                </g>
					<polyline id="XMLID_7_" class="st4" points="426.9,472.4 432.3,447.8 457.3,453.2         " />
					<polyline id="XMLID_6_" class="st4" points="578.2,535.2 572.8,559.7 547.7,554.2         " />
            </g>
				<g id="XMLID_1_">
                <path id="XMLID_90_" class="st11" d="M562.1,632.2c-2.7,10.7-13.7,17.1-24.4,14.4l-178.4-45.9c-10.7-2.7-17.1-13.7-14.4-24.4
            l23.3-90.5c2.7-10.7,13.7-17.1,24.4-14.4L571,517.3c10.7,2.7,17.1,13.7,14.4,24.4L562.1,632.2z" />
            </g>
				<g id="XMLID_52_">
                <polyline id="XMLID_3_" class="st12" points="363.7,507.3 449,529.3 437.5,574 352.2,552      " />
					<circle id="XMLID_4_" class="st13" cx="422.3" cy="546.3" r="9.5" />
					<path id="XMLID_29_" class="st14" d="M417.4,544.9c0.7-2.7,3.5-4.4,6.3-3.7" />
            </g>
        </g>
			<g id="XMLID_45_">
            <path id="XMLID_47_" class="st0" d="M491.3,649.7l4.5,0.1c5.1,0.1,9.5-4,9.6-9.2l0.9-39.3c0.1-5.1-4-9.5-9.2-9.6l-4.5-0.1
        c-5.1-0.1-9.5,4-9.6,9.2l-0.9,39.3C482,645.3,486.1,649.6,491.3,649.7z" />
				<path id="XMLID_46_" class="st7" d="M493.6,652.5c-7.9-0.2-14.2-6.8-14-14.7l0.9-34.8c0.2-7.9,6.8-14.2,14.7-14
        c7.9,0.2,14.2,6.8,14,14.7l-0.9,34.8C508,646.4,501.4,652.6,493.6,652.5z M494.9,594.2c-5-0.1-9.2,3.8-9.3,8.8l-0.9,34.8
        c-0.1,5,3.8,9.2,8.8,9.3c5,0.1,9.2-3.8,9.3-8.8l0.9-34.8C503.8,598.5,499.8,594.4,494.9,594.2z" />
        </g>
			<g id="XMLID_40_">
            <path id="XMLID_42_" class="st0" d="M466.5,654.8l4.5,0.1c5.1,0.1,9.5-4,9.6-9.2l0.9-39.3c0.1-5.1-4-9.5-9.2-9.6l-4.5-0.1
        c-5.1-0.1-9.5,4-9.6,9.2l-0.9,39.3C457.2,650.4,461.3,654.8,466.5,654.8z" />
				<path id="XMLID_41_" class="st7" d="M468.7,657.6c-7.9-0.2-14.2-6.8-14-14.7l0.9-34.8c0.2-7.9,6.8-14.2,14.7-14
        c7.9,0.2,14.2,6.8,14,14.7l-0.9,34.8C483.2,651.5,476.6,657.8,468.7,657.6z M470.1,599.4c-5-0.1-9.2,3.8-9.3,8.8l-0.9,34.8
        c-0.1,5,3.8,9.2,8.8,9.3c5,0.1,9.2-3.8,9.3-8.8l0.9-34.8C479,603.7,475.1,599.5,470.1,599.4z" />
        </g>
			<g id="XMLID_35_">
            <path id="XMLID_37_" class="st0" d="M443.4,654.7l4.5,0.1c5.1,0.1,9.5-4,9.6-9.2l0.9-39.3c0.1-5.1-4-9.5-9.2-9.6l-4.5-0.1
        c-5.1-0.1-9.5,4-9.6,9.2l-1,39.3C434,650.3,438.1,654.6,443.4,654.7z" />
				<path id="XMLID_36_" class="st7" d="M445.5,657.5c-7.9-0.2-14.2-6.8-14-14.7l0.9-34.8c0.2-7.9,6.8-14.2,14.7-14
        c7.9,0.2,14.2,6.8,14,14.7l-0.9,34.8C460,651.4,453.4,657.7,445.5,657.5z M446.9,599.2c-5-0.1-9.2,3.8-9.3,8.8l-0.9,34.8
        c-0.1,5,3.8,9.2,8.8,9.3c5,0.1,9.2-3.8,9.3-8.8l0.9-34.8C455.8,603.5,451.9,599.4,446.9,599.2z" />
			</g>
			<g id="XMLID_30_">
            <path id="XMLID_32_" class="st0" d="M420.1,654.6l4.5,0.1c5.1,0.1,9.5-4,9.6-9.2l0.9-39.3c0.1-5.1-4-9.5-9.2-9.6l-4.5-0.1
        c-5.1-0.1-9.5,4-9.6,9.2l-0.9,39.3C410.8,650.1,414.9,654.5,420.1,654.6z" />
				<path id="XMLID_31_" class="st7" d="M422.3,657.2c-7.9-0.2-14.2-6.8-14-14.7l0.9-34.8c0.2-7.9,6.8-14.2,14.7-14
        c7.9,0.2,14.2,6.8,14,14.7l-0.9,34.8C436.7,651.1,430.2,657.4,422.3,657.2z M423.7,599c-5-0.1-9.2,3.8-9.3,8.8l-0.9,34.8
        c-0.1,5,3.8,9.2,8.8,9.3c5,0.1,9.2-3.8,9.3-8.8l0.9-34.8C432.6,603.3,428.6,599.3,423.7,599z" />
			</g>
	</g>
</template>

<script>
	import { TimelineLite, Power0  } from 'gsap'

	export default {
		name: "IconMoney.vue",
		data: function () {
			return {
				tl:undefined,
			}
		},
		mounted() {
			this.tl = new TimelineLite();
			this.bay();
		},
		methods:{
			hello() {
				this.tl.set('#icon--money', {opacity:1});
				this.tl.to('#icon--money',0.25 ,{y:1, ease: Power0.easeNone});
			},
			bay() {
				this.tl.to('#icon--money',0.5 ,{y:-1000, ease: Power0.easeNone});
				this.tl.set('#icon--money',{y:-1000, opacity:0});

			}
		}

	}
</script>

<style scoped>
	body {
		margin: 0;
		padding: 0
	}

	.st0 {
		fill: #F2DCC0;
	}

	.st1 {
		fill: #61AD86;
	}

	.st2 {
		fill: #6BBC95;
	}

	.st3 {
		fill: #82C4A4;
	}

	.st4 {
		fill: #4E8064;
	}

	.st5 {
		enable-background: new;
	}

	.st6 {
		fill: #FFFFFF;
	}

	.st7 {
		fill: #E4C5A5;
	}

	.st8 {
		fill: none;
		stroke: #F07D22;
		stroke-width: 65;
		stroke-miterlimit: 10;
	}

	.st9 {
		fill: #E05E26;
	}

	.st10 {
		fill: #7A421C;
	}

	.st11 {
		fill: #8E5623;
	}

	.st12 {
		fill: none;
		stroke: #7A421C;
		stroke-width: 5;
		stroke-miterlimit: 10;
	}

	.st13 {
		fill: #EEB61E;
	}

	.st14 {
		fill: none;
		stroke: #C48A2B;
		stroke-width: 3;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-miterlimit: 10;
	}

	#hand {
		height: 500px;
		margin: 0 auto;
		display: block;
		text-align: center;
	}

	g#money-front-right {

	}


</style>
